var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-layout__container"},_vm._l((_vm.slots),function(widget,index){return _c('preview-slot',{key:index,style:(Object.assign({}, _vm.gridItemStyles(widget))),attrs:{"index":index,"widget":widget,"slots":_vm.slots}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }